(function () {
  'use strict';

  function createWorkflowController($state, $sce,
    workflowConfigurationData, entity, workflowDataService, sessionData) {
      var vm = this;
      vm.entity = entity;
      vm.configuration = workflowConfigurationData;
      vm.viewModel = {};
      vm.errors = [];
      vm.workflowIconStyle = vm.configuration.IconFileName ?
      "background:url('/images/icons/" + vm.configuration.IconFileName +
      "');background-repeat: no-repeat;background-position: center" :
      "";

      if ($state.params.t == 2  && sessionData.PlatformId === "Platforms/renu") {
        vm.showFormstack = true;
        var formstackFormName = "renu_coverage_application";
        vm.formstack = {
          formUrl: "https://buildify.formstack.com/forms/" + formstackFormName,
          formName: formstackFormName,
          formTitle: "ReNu Coverage Application"
        };
      }

      vm.trustSrc = function(src) {
        return $sce.trustAsResourceUrl(src);
      }

      vm.submit = function submit() {
        vm.hideButtons = true;
        if (vm.entity) {
          workflowDataService.createWorkflowForEntity(vm.entity.Id, vm.viewModel,
            $state.params.t)
            .then(function (response) {
              if (response.isError) {
                vm.errors = response.Errors;
                vm.hideButtons = false;
              }
              else {
                $state.go('workflow', { workflowId: response.WorkflowId.split('/')[1] });
              }
            });
        }
        else {
          workflowDataService.createWorkflow(vm.viewModel, $state.params.t)
            .then(function (response) {
              if (response.isError) {
                vm.errors = response.Errors;
                vm.hideButtons = false;
              }
              else {
                $state.go('workflow', { workflowId: response.WorkflowId.split('/')[1] });
              }
            });
        }
      };

      vm.goBack = function () {
        $state.go('dashboard');
      }
  }

  createWorkflowController.$inject = ['$state', '$sce',
  'workflowConfigurationData', 'entity', 'workflowDataService', 'sessionData'
  ];

  angular.module('ecap.workflow').controller('createWorkflowController', createWorkflowController);
})();